import { Component, OnInit, Inject } from '@angular/core';
import { ItemsService } from '@scaffold/services/items.service';
import { AddDataComponent } from '@scaffold/dialogs/add-data/add-data.component';
import { CourseService } from '../../../services/course.service';
import { ViewsService } from '../../../../services/views.service';
import { NbDialogRef, NbDialogService } from '@nebular/theme';

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss']
})
export class SearchModalComponent implements OnInit {

  constructor(public dialogRef: NbDialogRef<SearchModalComponent>, public dialog: NbDialogService, private itemsService: ItemsService, public courseService: CourseService, public viewsService: ViewsService) { }
  selected;
  route;
  data: any = {};
  createDialog: NbDialogRef<AddDataComponent>;
  ngOnInit() {
    console.log(this.data);
    this.route = this.data.route;
  }

  setSelected(item) {
    console.log(item)
      this.selected = item;
  }

  createData(type, parent) {
    console.log(parent)
    let settings: any = {
      context:{
      data: {
        comp: this,
        parent: parent,
        type: type,
        allowAdd: true
      }
    }
    };
    this.createDialog = this.dialog.open(AddDataComponent, settings);
    this.createDialog.onClose.subscribe(result => {
      console.log(result)
      if (result && (result !== 'string' || result.length > 0)) {
        console.log(result);
        this.dialogRef.close(result.id);
        }
      
    });
  }

  closeDialog(item) {
    if (item) {
      this.dialogRef.close(item);
    } else {
      this.dialogRef.close(null);
    }
  }

}
